// extracted by mini-css-extract-plugin
module.exports = {"header":"TelegramAuthLayout_header__7QL4A","logo":"TelegramAuthLayout_logo__8Zgwt","content":"TelegramAuthLayout_content__zcJsT"};